import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Stays from "@/pages/Stays";
import PropertyDetail from "@/pages/PropertyDetail";
import Compare from "@/pages/Compare";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AlertsManage from "@/pages/AlertsManage";
import Bookings from "@/pages/Bookings";
import AdminSync from "@/pages/AdminSync";
import HotelReviews from "@/pages/HotelReviews";
import Experiences from "@/pages/Experiences";

function App() {
  return (
    <AppProvider>
      <FavoritesProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/stays" element={<Stays />} />
              <Route path="/stay/:slug" element={<PropertyDetail />} />
              <Route path="/stay/:slug/reviews" element={<HotelReviews />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/alerts" element={<AlertsManage />} />
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<AdminSync />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SmoothScroll>
          <Toaster position="bottom-right" richColors closeButton />
        </BrowserRouter>
      </FavoritesProvider>
    </AppProvider>
  );
}

export default App;
